import {
    ChangeDetectionStrategy,
    Component,
    effect,
    inject,
    output,
    OutputEmitterRef,
    signal,
    WritableSignal
} from "@angular/core";
import {OrderModel} from "../order.model";
import {NgClass} from '@angular/common';
import {IconComponent} from '../../ui-elements/icon/icon.component';
import {DealModel} from '../../deal/deal.model';
import {ActivatableDirective} from '../../ui-elements/activatable.directive';

@Component({
    selector: "woa-order-summary-icon",
    templateUrl: "./order-summary-icon.component.html",
    styleUrl: "./order-summary-icon.component.scss",
    imports: [
        IconComponent,
        NgClass,
        ActivatableDirective
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class OrderSummaryIconComponent {
    public orderModel: OrderModel = inject(OrderModel);
    public dealModel: DealModel = inject(DealModel);

    public onOrderSummary: OutputEmitterRef<void> = output<void>();

    public readonly highlighted: WritableSignal<boolean> = signal<boolean>(false);

    constructor() {
        if (this.orderModel.orderStarted() || this.dealModel.appliedDeals().length) {
            this.highlight();
        }

        effect(() => {
            if (this.orderModel.totalItems()) {
                this.highlight();
            }
        });

        effect(() => {
            if (this.dealModel.appliedDeals().length) {
                this.highlight();
            }
        });
    }

    highlight(): void {
        this.highlighted.set(true);
        setTimeout(() => {
            this.highlighted.set(false);
        }, 3000);
    }
}
